import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.applyTheme(this.currentTheme)
  }

  toggle() {
    const newTheme = this.currentTheme === "dark" ? "light" : "dark"
    this.applyTheme(newTheme)
    this.saveTheme(newTheme)
  }

  applyTheme(theme) {
    document.documentElement.classList.toggle("dark", theme === "dark")
  }

  saveTheme(theme) {
    try {
      localStorage.setItem("theme", theme)
    } catch (e) {
    }
  }

  get currentTheme() {
    let saved = null
    try {
      saved = localStorage.getItem("theme")
    } catch (e) {
    }
    return saved ||
      (window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light")
  }
}
